<div>
  <div class="tw-mb-2">
    <h4 class="tw-m-0">{{ 'poUploadCart.title' | cxTranslate }}</h4>
  </div>
  <div *ngIf="entries$ | async as entries"
       class="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center lg:tw-items-start lg:tw-flex-col lg:tw-justify-center">
    <button
      (click)="goToPOUpload()"
      class="tw-cursor-pointer tw-font-sans tw-text-base tw-px-8 tw-py-3 tw-bg-white tw-text-primary-violet tw-mb-4 tw-w-full md:tw-mb-0 lg:tw-mb-4 md:tw-w-1/2 lg:tw-w-full
      tw-rounded tw-border tw-border-primary-violet tw-border-solid
      focus-visible:tw-outline-primary-violet focus-visible:tw-outline-dotted focus-visible:tw-outline-offset-1 focus-visible:tw-outline-1 focus-visible:tw-bg-primary-violet/10
      hover:tw-bg-primary-violet/10 active:tw-bg-primary-violet/20">
      {{ 'poUploadCart.proceedToUploadForm' | cxTranslate }}
    </button>
    <div class="tw-w-full md:tw-w-1/2 lg:tw-w-full tw-text-center tw-px-8
      tw-py-3">
      <a routerLink="/myaccount/orders">
        <span class="tw-text-primary-violet"> {{ 'poUploadCart.viewOrderHistory' | cxTranslate }}</span>
      </a>
    </div>
  </div>
</div>
